import FightEventComponent from "./FightEventComponent";

export default FightEventComponent;